module.exports = __webpack_public_path__ + "img/SHZL.3d94f871.png";